import { tourStep } from './tourRegistry';

export const bandaFormacionesSteps = [
  tourStep(
    'formaciones-bloqueada-alert',
    'Primero, músicos',
    'Las formaciones se montan colocando músicos en la plantilla. Añade al menos uno en <strong>Mis músicos</strong> para desbloquear esta sección.',
  ),
  tourStep(
    'formaciones-sidebar',
    'Mis formaciones',
    'Cada formación es una plantilla (procesión, concierto…). Elige una en la lista o crea una nueva.',
  ),
  tourStep(
    'formaciones-nueva',
    'Nueva formación',
    'Nombre y tipo. Luego colocas músicos en el editor de la derecha.',
  ),
  tourStep(
    'formaciones-editor',
    'Editor',
    'Coloca a la plantilla en el escenario o la procesión. Puedes exportar un PDF de la formación seleccionada.',
  ),
];
